var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"envName":"养殖环境","envInfoType":2}})}
var staticRenderFns = []

export { render, staticRenderFns }